import { defineMessages } from 'react-intl';

export default defineMessages({
	widgetErrorTitle: {
		id: 'csm.chat-widget.error-boundary.title',
		defaultMessage: 'Support widget unavailable',
		description: 'Title for the error flag for when the widget failed to load',
	},
	widgetErrorDescription: {
		id: 'csm.chat-widget.error-boundary.description',
		defaultMessage: 'The AI Agent failed to load. Please refresh the page to try again.',
		description: 'Description for the error flag for when the widget failed to load',
	},
});
